var _path, _g, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViolinPlot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "8 8 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4046_28422",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 11,
    width: 38,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6295 11.0135C31.6295 11.0135 32.6852 13.7758 26.2201 16.1443C23.6581 17.0864 20.4015 18.3202 20.4015 19.6094C20.4043 21.1412 24.1753 22.8939 27.0384 23.8513C30.2386 24.9741 31.9205 27.1782 31.7829 29.0821C31.7016 30.2724 28.4293 31.7813 24.324 32.3612C16.9279 33.4252 12.7902 35.6218 13.0082 38.4777C13.1615 40.6383 15.6109 41.6088 18.9884 42.9513C20.2574 43.4561 21.6954 44.0273 23.1824 44.7312C27.0615 46.621 31.8133 48.3233 31.8133 50.8389C31.8226 50.8531 31.6487 57.0002 32.0064 57C32.364 56.9998 32.2132 50.8542 32.2216 50.8411C32.2216 48.3019 36.9743 46.6221 40.8109 44.7791C42.2979 44.0654 43.7359 43.4942 45.0049 42.9992C48.3908 41.6577 50.8392 40.6862 50.9935 38.5255C51.1874 35.7078 47.0654 33.4709 39.6389 32.4037C35.5335 31.8227 32.0147 30.2713 31.9344 29.0821C31.794 27.1304 33.6882 25.0165 36.9208 23.8937C39.7839 22.8939 43.5604 21.1902 43.5604 19.6572C43.5604 18.3626 40.3066 17.1441 37.7418 16.1921C31.2924 13.8215 31.9986 11.0133 31.9986 11.0133C32.035 11.0176 31.9742 10.9813 31.9986 11.0133C32.0151 11.0062 31.9811 11.0121 31.9986 11.0133C31.9821 11.0204 31.6423 10.9993 31.6295 11.0135Z",
    fill: "#8CBFFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4046_28422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6295 11.0135C31.6295 11.0135 32.6852 13.7758 26.2201 16.1443C23.6581 17.0864 20.4015 18.3202 20.4015 19.6094C20.4043 21.1412 24.1753 22.8939 27.0384 23.8513C30.2386 24.9741 31.9205 27.1782 31.7829 29.0821C31.7016 30.2724 28.4293 31.7813 24.324 32.3612C16.9279 33.4252 12.7902 35.6218 13.0082 38.4777C13.1615 40.6383 15.6109 41.6088 18.9884 42.9513C20.2574 43.4561 21.6955 44.0273 23.1824 44.7312C27.0615 46.621 31.8133 48.3233 31.8133 50.8389C31.8226 50.8531 31.6487 57.0002 32.0064 57C32.364 56.9998 32.2133 50.8542 32.2216 50.8411C32.2216 48.3019 36.9743 46.6221 40.8109 44.7791C42.2979 44.0654 43.7359 43.4942 45.0049 42.9992C48.3908 41.6577 50.8392 40.6862 50.9935 38.5255C51.1874 35.7078 47.0654 33.4709 39.6389 32.4037C35.5335 31.8227 32.0147 30.2713 31.9344 29.0821C31.794 27.1304 33.6882 25.0165 36.9208 23.8937C39.7839 22.8939 43.5604 21.1902 43.5604 19.6572C43.5604 18.3626 40.3066 17.1441 37.7418 16.1921C31.2924 13.8215 31.9986 11.0133 31.9986 11.0133C32.035 11.0176 31.9742 10.9813 31.9986 11.0133C32.0151 11.0062 31.9811 11.0121 31.9986 11.0133C31.9821 11.0204 31.6423 10.9993 31.6295 11.0135Z",
    fill: "#8CBFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 29,
    width: 38,
    height: 28,
    fill: "#3B82C9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9V57H56",
    stroke: "#B3B3B3",
    strokeWidth: 0.990534,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViolinPlot);
export default __webpack_public_path__ + "static/media/violin_plot.361b3814.svg";
export { ForwardRef as ReactComponent };